/* eslint-disable */

export default {
  init() {
    // JavaScript to be fired on the Single Product page
    // if the product is variable, set the Add to Cart URL, set the Buy Now button URL
    // and create an event handler for variation dropdown menu changes
    // http://epionce.com/cart/?add-to-cart=123&variation_id=456&quantity=1
    if ($('.product-detail__details__shop-actions__variation__select').length) {
      const variationSelect = $('.product-detail__details__shop-actions__variation__select');
      const isSale = variationSelect.attr('data-is-sale');
      const selectedOption = variationSelect.find(':selected');
      const variationValue = selectedOption.attr('data-variation-encoded');
      const regularPrice = selectedOption.attr('data-regular-price');
      const salePrice = selectedOption.attr('data-price');
      const productId = variationSelect.attr('data-product-id');
      const variationId = variationSelect.val();
      const quantity = $('#number-spinner-input').val();
      const baseUrl = $('.product-detail__details__shop-actions').attr('data-base-url');
      if (isSale === 'true') {
        $('.sale-price').text(salePrice);
        $('.regular-price').text(regularPrice);
      } else {
        $('.regular-price').text(regularPrice);
      }
      $('.product-detail__details__shop-actions__add-to-bag__btn').attr('href', `${baseUrl}?add-to-cart=${productId}&variation_id=${variationId}&attribute_size=${variationValue}&quantity=${quantity}`);
      $('.product-detail__details__shop-actions__buy-now__btn').attr('href', `${baseUrl}shopping-bag/?add-to-cart=${productId}&variation_id=${variationId}&attribute_size=${variationValue}&quantity=${quantity}`);

      // attach event handler to the variation select dropdown
      $('.product-detail__details__shop-actions__variation__select').on('change',e => {
        const variationSelect = $('.product-detail__details__shop-actions__variation__select');
        const isSale = variationSelect.attr('data-is-sale');
        const selectedOption = variationSelect.find(':selected');
        const variationValue = selectedOption.attr('data-variation-encoded');
        const regularPrice = selectedOption.attr('data-regular-price');
        const salePrice = selectedOption.attr('data-price');
        const productId = variationSelect.attr('data-product-id');
        const variationId = variationSelect.val();
        const quantity = $('#number-spinner-input').val();
        const baseUrl = $('.product-detail__details__shop-actions').attr('data-base-url');
        if (isSale === 'true') {
          $('.sale-price').text(salePrice);
          $('.regular-price').text(regularPrice);
        } else {
          $('.regular-price').text(regularPrice);
        }
        $('.product-detail__details__shop-actions__add-to-bag__btn').attr('href', `${baseUrl}?add-to-cart=${productId}&variation_id=${variationId}&attribute_size=${variationValue}&quantity=${quantity}`);
        $('.product-detail__details__shop-actions__buy-now__btn').attr('href', `${baseUrl}shopping-bag/?add-to-cart=${productId}&variation_id=${variationId}&attribute_size=${variationValue}&quantity=${quantity}`);
      });

      $('.product-detail__details__shop-actions__quantity__number-spinner').on('click','.input-group-btn',e => {
        const variationSelect = $('.product-detail__details__shop-actions__variation__select');
        const selectedOption = variationSelect.find(':selected');
        const variationValue = selectedOption.attr('data-variation-encoded');
        const productId = variationSelect.attr('data-product-id');
        const variationId = variationSelect.val();
        const quantity = $('#number-spinner-input').val();
        const baseUrl = $('.product-detail__details__shop-actions').attr('data-base-url');
        $('#number-spinner-input').trigger('change');
        $('.product-detail__details__shop-actions__add-to-bag__btn').attr('href', `${baseUrl}?add-to-cart=${productId}&variation_id=${variationId}&attribute_size=${variationValue}&quantity=${quantity}`);
        $('.product-detail__details__shop-actions__buy-now__btn').attr('href', `${baseUrl}shopping-bag/?add-to-cart=${productId}&variation_id=${variationId}&attribute_size=${variationValue}&quantity=${quantity}`);
      });
    } else {
      $('.product-detail__details__shop-actions__quantity__number-spinner').on('click','.input-group-btn',e => {
        $('#number-spinner-input').trigger('change');
        const baseUrl = $('.product-detail__details__shop-actions').attr('data-base-url');
        const productId = $('.product-detail__details__shop-actions__buy-now__btn').attr('data-product-id');
        const quantity = $('#number-spinner-input').val();
        $('.product-detail__details__shop-actions__add-to-bag__btn').attr('href', `${baseUrl}?add-to-cart=${productId}&quantity=${quantity}`);
        $('.product-detail__details__shop-actions__buy-now__btn').attr('href', `${baseUrl}shopping-bag/?add-to-cart=${productId}&quantity=${quantity}`);
      });
    }
  },
  finalize() {
    // JavaScript to be fired on the Single Product page, after the init JS
    const hideDynamicPricing = $('.product-detail__details__price').attr('data-hide-dynamic-pricing');

    // JavaScript to be fired on the single product page, after the init JS
    /**
     * Comment out pro pricing 2020-10-22 per Trish's request
     */
    if ($('.product-detail__details__price').length && (products.userRole === 'pro')) {
      // if (hideDynamicPricing == 1) {
      //   // If Hide dynamic pricing
      //   var price = parseFloat($('.product-detail__details__price').find('.regular-price').text().substr(1));
      //   if ($('.product-detail__details__price').find('.sale-price').length) {
      //     price = parseFloat($('.product-detail__details__price').find('.sale-price').text().substr(1));
      //   }

      //   var proPrice = (price-(price*0.50)).toFixed(2);

      //   if ($('.product-detail__details__price').find('.sale-price').length) {
      //     $('.product-detail__details__price').find('.sale-price').text(`$${proPrice}`);
      //   } else {
      //     $('.product-detail__details__price').find('.regular-price').text(`$${proPrice}`);
      //   }

      //   // event handler for the qty select field
      //   $('#number-spinner-input').on('change',e => {
      //     if ($('.product-detail__details__price').find('.sale-price').length) {
      //       $('.product-detail__details__price').find('.sale-price').text(`$${proPrice}`);
      //     } else {
      //       $('.product-detail__details__price').find('.regular-price').text(`$${proPrice}`);
      //     }
      //   });


      //   $('.product-detail__details__shop-actions__quantity__number-spinner').on('click','.input-group-btn',e => {
      //     $('#number-spinner-input').trigger('change');
      //   });
      // } else {
      //   var price = parseFloat($('.product-detail__details__price').find('.regular-price').text().substr(1));
      //   if ($('.product-detail__details__price').find('.sale-price').length) {
      //     price = parseFloat($('.product-detail__details__price').find('.sale-price').text().substr(1));
      //   }

      //   const tableHtml = `<div class="product-detail__details__pro-pricing-table-container"><p class="product-detail__details__pro-pricing-table-title">Professional Pricing</p><table class="product-detail__details__pro-pricing-table"><thead><th>Qty</th><th>Price</th></thead><tr><td>1 - 11</td><td>${(price-(price*0.50)).toFixed(2)}</td></tr><tr><td>12 - 59</td><td>${(price-(price*0.55)).toFixed(2)}</td></tr><tr><td>60+</td><td>${(price-(price*0.575)).toFixed(2)}</td></tr></table></div>`;
      //   $('.product-detail__details__price').after(tableHtml);
      //   const qty = $('#number-spinner-input').val();
      //   if (qty > 0 && qty < 12) {
      //     var proPrice = (price-(price*0.50)).toFixed(2);
      //   } else if ((11 < qty) && (qty < 60)) {
      //     var proPrice = (price-(price*0.55)).toFixed(2);
      //   } else {
      //     // greater than 60
      //     var proPrice = (price-(price*0.575)).toFixed(2);
      //   }

      //   if ($('.product-detail__details__price').find('.sale-price').length) {
      //     $('.product-detail__details__price').find('.sale-price').text(`$${proPrice}`);
      //   } else {
      //     $('.product-detail__details__price').find('.regular-price').text(`$${proPrice}`);
      //   }

      //   // event handler for the qty select field
      //   $('#number-spinner-input').on('change',function(e){
      //     const qty = $(this).val();
      //     if (qty > 0 && qty < 12) {
      //       var proPrice = (price-(price*0.50)).toFixed(2);
      //     } else if ((11 < qty) && (qty < 60)) {
      //       var proPrice = (price-(price*0.55)).toFixed(2);
      //     } else {
      //       // greater than 60
      //       var proPrice = (price-(price*0.575)).toFixed(2);
      //     }

      //     if ($('.product-detail__details__price').find('.sale-price').length) {
      //       $('.product-detail__details__price').find('.sale-price').text(`$${proPrice}`);
      //     } else {
      //       $('.product-detail__details__price').find('.regular-price').text(`$${proPrice}`);
      //     }
      //   });


      //   $('.product-detail__details__shop-actions__quantity__number-spinner').on('click','.input-group-btn',e => {
      //     $('#number-spinner-input').trigger('change');
      //   });
      // }
    }

    // add the code to detect if we need to prepend Pro pricing label to bulk price
    if ($('.product-detail__post-price > .woocommerce-Price-amount:first-child').length && (products.userRole === 'pro')) {
      $('.product-detail__post-price > .woocommerce-Price-amount:first-child, .product-detail__post-price > ins > .woocommerce-Price-amount:first-child').each((i, e) => {
        const $price = $(e).clone();
        $price.find('.woocommerce-Price-currencySymbol').remove();
        const priceValue = parseFloat($price.html());
        // Github Issue #470
        // $(e).closest('.product-detail__post-price').html(`<p>Pro Pricing starts at $${(priceValue-(priceValue*0.50)).toFixed(2)}</p>`);
      }).promise().done(() => {
        $('.product-detail__post-content-wrapper').matchHeight();
        // $grid.isotope();
      });
    } else {
      // $grid.isotope();
    }

    // matchHeight.js
    $(() => {
      $('.product-detail__post-content-wrapper').matchHeight();
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/singleProduct.js